import { createAction } from 'redux-actions';

export const SET_CHATS_HISTORY = 'CHATS_HISTORY::SET';
export const SET_CHAT_HISTORY = 'CHATS_HISTORY::SET_ITEM';
export const RESET_CHATS_HISTORY = 'CHATS_HISTORY::RESET';

export const setChatsHistory = createAction(SET_CHATS_HISTORY);
export const setChatHistory = createAction(SET_CHAT_HISTORY);
export const resetChatsHistory = createAction(RESET_CHATS_HISTORY);
